import useApiErrorHandling from '../../useApiErrorHandling';

// Wraps a request fn with recursive force-retry, then runs the initial call.
// onSuccess fires after a successful request (initial or retry) — the string
// flow uses it to refetch (legacy auto-reload); the detailed flow relies on
// responseActions.reload instead and leaves it undefined.
// On success returns the response body; on a handled error returns whatever
// handleApiError yields (the retried body for force-retries, otherwise the
// Error/null), so callers must validate the shape — the aggregate flow guards
// with Array.isArray before consuming it.
export const executeWithForceRetry = async <T>(
  makeRequest: (forceHeader?: string) => Promise<T>,
  handleApiError: ReturnType<typeof useApiErrorHandling>,
  onSuccess?: () => void
): Promise<T | undefined> => {
  const retryWithForce = async (
    forceHeader: string
  ): Promise<T | undefined> => {
    try {
      const res = await makeRequest(forceHeader);
      if ((res as { ok?: boolean })?.ok) onSuccess?.();
      return res;
    } catch (retryError) {
      if (retryError instanceof Error) {
        return await handleApiError(retryError, false, retryWithForce);
      }
    }
  };

  try {
    const res = await makeRequest();
    if ((res as { ok?: boolean })?.ok) onSuccess?.();
    return res;
  } catch (e) {
    if (e instanceof Error) {
      return await handleApiError(e, false, retryWithForce);
    }
  }
};
